<script>

import BlockEditor from "../../../../../../../js/common/canvas/editor/canvas/document/editors/BlockEditor";

export default {

    extends: BlockEditor,

    data() {
        return {
            saveButton: null,
            isDirty: false,
        };
    },

    created() {
        this.initEditing();
        this.initMinimumWidth();
    },

    methods: {

        initEditing() {
            this.element

                // Listen for interaction.
                .focus(this.manageSaveButton)
                .keydown(this.onKeyDown)
                .on('input', this.onInput)

                // Avoid dropping images, HTML etc.
                .on('drop', () => false)
                .on('paste', this.removeHtml);

            this.manageEditing();
        },

        manageSaveButton() {
            // Add or remove
            if (this.isSelected && !this.saveButton)
                this.addSaveButton();

            else if (!this.isSelected && this.saveButton)
                this.removeSaveButton();

            // Manage disabled state?
            if (this.isSelected)
                this.saveButton.attr('disabled', !this.isDirty);
        },

        addSaveButton() {
            // Get offset.
            let offset = this.element.offset();

            // Add button.
            this.saveButton = $('<button class="btn btn-sm btn-success px-3 ml-2 save" style="background: #55ce63; border: 1px solid #55ce63; border-radius: .2rem; color: white; font-size: .875rem; font-weight: 400; line-height: 1.5; padding: .25rem 1rem; position: absolute" disabled>Opslaan</button>')
                .click(() => this.save())
                .hover(event => $(event.currentTarget).css('opacity', .7), event => $(event.currentTarget).css('opacity', 1))
                .appendTo('body')
                .css({
                    left: offset.left + this.element.width() - 93,
                    top: offset.top - 30 - 5,
                });
        },

        removeSaveButton() {
            this.saveButton.remove();
            this.saveButton = null;
        },

        manageEditing() {
            this.element
                .attr('contenteditable', this.blockSelectionEnabled);
        },

        onKeyDown(event) {
            // Define which keys are allowed combined with CMD or CTRL
            let allowedMetakeyCombinations = ['a', 'c', 'v', 'Backspace'];

            // Prevent due to is saving thus we will loose the text soon it reloads the HTML.
            if (this.pageState.saving)
                return false;

            if (event.metaKey && allowedMetakeyCombinations.indexOf(event.key) !== -1) {
                return true;
            }

            // Avoid use of meta key (cmd)? To avoid cmd + b to get bold (HTML) text.
            if (event.metaKey)
                return false;

            // Avoid <br />? Save?
            if (event.key === 'Enter') {
                //
                this.save();

                // Avoid placing <br />
                return false;
            }

            // Make save button clickable.
            this.manageSaveButton();
        },

        onInput() {
            this.isDirty = true;

            this.manageSaveButton();
        },

        removeHtml() {
            // Remove potential HTML.
            setTimeout(() => {
                this.element.text(this.element.text());
            }, 1);
        },

        save() {
            //
            this.removeHtml();

            // Set
            this.$set(this.canvasBlock.options, 'text', this.element.text() || ' ');

            // Deselect
            this.pageComponent.selection.setSelection(null);
        },

        initMinimumWidth() {
            // Force block to be able to have a minimum width.
            let style = window.getComputedStyle(this.element.get(0));

            if (style.display == 'inline')
                this.element.css('display', 'inline-block');
        },

    },

    watch: {

        'blockSelectionEnabled'() {
            this.manageEditing();
        },

        'isSelected'(newVal) {
            // @ugly Not sure why needed.
            // Force blur?
            if (!newVal)
                this.element.blur();

            else
                this.element.focus();

            //
            this.manageSaveButton();
        },

    },

    computed: {

        isSelectable() {
            return true;
        },

    },

}

</script>
